import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { DB_TYPE } from '@/common/define/common.define';
import { findPermissionByTranslateId } from '@/common/permission/permission.utils';

export const DATABASE_DASHBOARD_PERMISSION_KEY_BY_DB_TYPE: Partial<Record<string, string>> = {
  [DB_TYPE.ALTIBASE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_ALTIBASE_DASHBOARD,
  [DB_TYPE.MYSQL]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_MYSQL_DASHBOARD,
  [DB_TYPE.ORACLE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_ORACLE_DASHBOARD,
  [DB_TYPE.POSTGRESQL]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_POSTGRESQL_DASHBOARD,
  [DB_TYPE.SQLSERVER]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_SQLSERVER_DASHBOARD,
  [DB_TYPE.TIBERO]: ROLE_PERMISSION_KEY.DASHBOARD.DASHBOARD_FEATURED_DASHBOARD,
  [DB_TYPE.SINGLESTORE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_SINGLESTORE_DASHBOARD,
};

export const getDatabaseDashboardPermissionKey = (dbType?: string) => {
  return dbType ? DATABASE_DASHBOARD_PERMISSION_KEY_BY_DB_TYPE[dbType] : undefined;
};

const isFeaturedDashboardPermissionKey = (rolePermissionKey: string) => {
  return rolePermissionKey === ROLE_PERMISSION_KEY.DASHBOARD.DASHBOARD_FEATURED_DASHBOARD;
};

/** DASHBOARD_FEATURED_DASHBOARD 권한으로 매핑된 DB(예: Tibero) — 편집 가능한 프리셋 대시보드 */
export const isEditablePresetDatabaseDashboard = (dbType?: string) => {
  const key = getDatabaseDashboardPermissionKey(dbType);
  return !!key && isFeaturedDashboardPermissionKey(key);
};

const getPermissionField = (rolePermissionKey: string) => {
  return isFeaturedDashboardPermissionKey(rolePermissionKey) ? 'listOnOff' : 'menuOnOff';
};

export const hasDatabaseDashboardPermission = (dbType: string | undefined) => {
  const rolePermissionKey = getDatabaseDashboardPermissionKey(dbType);
  if (!rolePermissionKey) {
    return true;
  }

  const permission = findPermissionByTranslateId(rolePermissionKey);
  return !!permission?.[getPermissionField(rolePermissionKey)];
};
